/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';

export default new Vue();

